import { createAction } from '@reduxjs/toolkit';
import {
    GET_TOKEN_BALANCE,
    GET_TOKEN_BALANCE_SUCCESS,
    GET_TOKEN_BALANCE_FAIL,
    GET_TOKEN_PACKAGES,
    GET_TOKEN_PACKAGES_SUCCESS,
    GET_TOKEN_PACKAGES_FAIL,
    PURCHASE_TOKENS,
    PURCHASE_TOKENS_SUCCESS,
    PURCHASE_TOKENS_FAIL,
    CONSUME_TOKENS,
    CONSUME_TOKENS_SUCCESS,
    CONSUME_TOKENS_FAIL,
    GET_TOKEN_COUNTDOWN,
    GET_TOKEN_COUNTDOWN_FAIL,
    GET_TOKEN_COUNTDOWN_SUCCESS,
} from './types';
import { ITokenBalance, ITokenPackage } from '../../types/global/token.types';
import { IErrorType } from '../../constants/types';

export interface IGetTokenBalancePayload {}
export interface IGetTokenBalanceSuccessPayload {
    balance: number;
    token: ITokenBalance;
}
export interface IGetTokenBalanceFailPayload {
    error: string;
}

export interface IGetTokenPackagesPayload {}
export interface IGetTokenPackagesSuccessPayload {
    packages: ITokenPackage[];
}
export interface IGetTokenPackagesFailPayload {
    error: string;
}

export interface IPurchaseTokensPayload {
    packageId: string;
    tokens: number;
    price: number;
    resolve: (value: any) => void;
    reject: (reason?: any) => void;
}
export interface IPurchaseTokensSuccessPayload {
    packageId: string;
    result: any;
}
export interface IPurchaseTokensFailPayload {
    error: string;
}

export interface IConsumeTokensPayload {
    submissionId: string;
    contestId: string;
    tokens: number;
    resolve: (value: any) => void;
    reject: (reason?: any) => void;
}
export interface IConsumeTokensSuccessPayload {
    submissionId: string;
    result: any;
}
export interface IConsumeTokensFailPayload {
    error: string;
}

export interface ITokenCountdownPayload {
    contestId: string;
}

export interface ITokenCountdownResponse {
    eligible: boolean;
    message: string | null;
    error: boolean;
    nextVoteTime: string | null;
    nextVoteIn: string | null;
}

export const getTokenBalance = createAction<IGetTokenBalancePayload>(GET_TOKEN_BALANCE);
export const getTokenBalanceSuccess = createAction<IGetTokenBalanceSuccessPayload>(GET_TOKEN_BALANCE_SUCCESS);
export const getTokenBalanceFail = createAction<IGetTokenBalanceFailPayload>(GET_TOKEN_BALANCE_FAIL);

export const getTokenPackages = createAction<IGetTokenPackagesPayload>(GET_TOKEN_PACKAGES);
export const getTokenPackagesSuccess = createAction<IGetTokenPackagesSuccessPayload>(GET_TOKEN_PACKAGES_SUCCESS);
export const getTokenPackagesFail = createAction<IGetTokenPackagesFailPayload>(GET_TOKEN_PACKAGES_FAIL);

export const purchaseTokens = createAction<IPurchaseTokensPayload>(PURCHASE_TOKENS);
export const purchaseTokensSuccess = createAction<IPurchaseTokensSuccessPayload>(PURCHASE_TOKENS_SUCCESS);
export const purchaseTokensFail = createAction<IPurchaseTokensFailPayload>(PURCHASE_TOKENS_FAIL);

export const consumeTokens = createAction<IConsumeTokensPayload>(CONSUME_TOKENS);
export const consumeTokensSuccess = createAction<IConsumeTokensSuccessPayload>(CONSUME_TOKENS_SUCCESS);
export const consumeTokensFail = createAction<IConsumeTokensFailPayload>(CONSUME_TOKENS_FAIL);

export const getTokenCountdown = createAction<ITokenCountdownPayload>(GET_TOKEN_COUNTDOWN);
export const getTokenCountdownSuccess = createAction<ITokenCountdownResponse>(GET_TOKEN_COUNTDOWN_SUCCESS);
export const getTokenCountdownFail = createAction<IErrorType>(GET_TOKEN_COUNTDOWN_FAIL);
